<div class="d-flex justify-content-center" style="margin-top: 15%">
    <div class=" img-logo">
        <div class="col-12 logo-full">
            <img src="/assets/img/geoprod-beta-version3.0.svg" style="margin:auto">
        </div>
        <h2 style="margin-top: 7%;">Adresse IP Non autorisée. <br> Pour nous contacter Veuillez <a href="http://geoprod.com/">cliquez ici.</a></h2>
    </div>
</div>
  